module.exports = __webpack_public_path__ + "media/images/icons/ic-map-marker-14feebbbe2d60ca96bfd6a6b728013ae.svg";